import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingColumns, faCheck, faCircleInfo, faClock } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";

import FluxopayReceivingAccountSection from "./FluxopayReceivingAccountSection";

import FluxopayUnifiedConditions from "./FluxopayUnifiedConditions";
import {fluxopayStatusLabel,} from "./fluxopayStatus";

function State({ title, value, description }) {
  const done = ["active", "approved", "verified"].includes(value);
  return <div className="fxpay-step">
    <span><FontAwesomeIcon icon={done ? faCheck : faClock} /></span>
    <div><b>{title}</b><small>{fluxopayStatusLabel(value)}</small><small>{description}</small></div>
  </div>
}

export default function FluxopaySettingsPanel({ entityName }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/api/fluxopay/commercial-conditions")
      .then(({ data: response }) => setData(response))
      .catch((requestError) => setError(requestError?.response?.data?.message || "Não foi possível carregar as condições comerciais."));
  }, []);

  if (error) return <section className="fxpay-card"><p className="fxpay-note">{error}</p></section>;
  if (!data) return <section className="fxpay-card">Carregando configurações...</section>;
  const { account, conditions = [], anticipation = {} } = data;

  return <>
    <div className="fxpay-grid fxpay-grid--settings">
    <section className="fxpay-card">
      <header><div><small>CONTA DIGITAL</small><h3>Configuração do Fluxopay</h3></div><span>{account?.status ? fluxopayStatusLabel(account.status) : "Não iniciada"}</span></header>
      <div className="fxpay-account">
        <span><FontAwesomeIcon icon={faBuildingColumns} /></span>
        <div><small>Titular</small><b>{entityName}</b><p>Provedor: <strong>{account?.provider || "Asaas"}</strong>{account?.provider_wallet_id ? ` · Carteira ${account.provider_wallet_id}` : " · Carteira não vinculada"}</p></div>
      </div>
      <State title="Cadastro e validação da conta" value={account?.status} description="Situação regulatória e operacional da subconta." />
      <State title="Recebimento por Pix" value={account?.pix_status} description="Disponibilidade para criar cobranças Pix." />
      <State title="Credenciamento de cartão" value={account?.card_status} description="Autorização para processar pagamentos online por cartão." />
      <p className="fxpay-note"><FontAwesomeIcon icon={faCircleInfo} /> Estes são estados retornados pelo provedor, não campos de edição. Alterações cadastrais exigem um fluxo próprio de validação.</p>
    </section>
    <aside className="fxpay-card">
      <header>
        <div>
          <small>{"CONDI\u00c7\u00d5ES VIGENTES"}</small>
          <h3>{"Composi\u00e7\u00e3o das taxas"}</h3>
        </div>
      </header>      
      <FluxopayUnifiedConditions
        platformConditions={conditions}
        anticipation={anticipation}
      />
      
    </aside>
  </div>
    <FluxopayReceivingAccountSection />
  </>;
}
